import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/process",
    name: "Process",
    component: () => import("../pages/Process.vue")
  },
  {
    path: "/form/:id",
    name: "quote",
    component: () => import("~/pages/form/Index.vue"),
    props: true,
    children: [
      {
        path: "customer-information",
        name: "quote.customer",
        component: () => import("~/pages/form/CustomerInformation.vue")
      },
      {
        path: "terms",
        name: "quote.terms",
        component: () => import("../pages/form/Terms.vue")
      },
      {
        path: "products",
        name: "quote.products",
        component: () => import("../pages/form/Products.vue")
      },
      {
        path: "summary",
        name: "quote.summary",
        component: () => import("../pages/form/Summary.vue")
      },
      {
        path: "preview",
        name: "quote.preview",
        component: () => import("../pages/form/Preview.vue")
      },
      {
        path: "invalid",
        name: "quote.invalid",
        component: () => import("../pages/form/Invalid.vue")
      }
    ]
  },
  {
    path: "/error",
    name: "InternalError",
    component: () => import("../pages/errors/InternalError.vue")
  },
  {
    path: "/*",
    name: "NotFound",
    component: () => import("../pages/errors/NotFound.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
